import { column, edge, flow, makeFlow, node } from "../builders";
import type { TemplateDef } from "../types";

const seq = column("f1", 100, 70, 92, [
  ["t1", "auto-trigger", "Contract signed", { props: { triggerType: "Pipeline Stage Changed", event: "Sales → Closed Won" } }],
  ["e1", "auto-email", "Welcome — the 3 things we need", { props: { subject: "Welcome aboard — here's exactly what happens next" } }],
  ["k1", "auto-task", "Set up the client workspace", { props: { assignee: "Ops", due: "+2 days" } }],
  ["w1", "auto-wait", "Wait 2 days", { props: { duration: "2", unit: "days" } }],
  ["c1", "auto-condition", "Intake form done?", { props: { condition: "Has tag 'intake-complete'" } }],
  ["s1", "auto-sms", "Nudge for the intake form", { props: { message: "Hi {{contact.first_name}} — we're blocked on the intake form: {{link.intake}}" } }],
  ["e2", "auto-email", "Kickoff call — pick a time", { props: { subject: "Let's kick off — grab a slot" } }],
  ["w2", "auto-wait", "Wait 7 days", { props: { duration: "7", unit: "days" } }],
  ["e3", "auto-email", "Week one recap", { props: { subject: "What we did in week one" } }],
  ["tg", "auto-tag-add", "Tag: client-onboarded", { props: { tag: "client-onboarded" } }],
]);

const def: TemplateDef = {
  slug: "agency-client-onboarding",
  name: "Agency Client Onboarding",
  category: "Agency",
  tagline:
    "The first two weeks decide the retainer — run them the same way every time.",
  description:
    "A free agency onboarding template: a closed-won pipeline move kicks off the welcome email, the workspace task, an intake-form chase and the kickoff booking, then a week-one recap that sets the reporting rhythm. Clone it into FrazzleCRM so every client gets the same first fortnight.",
  whatsInside: [
    "Closed-won pipeline trigger — no one has to remember to start it",
    "Welcome email that states the three things you need on day one",
    "Intake-form branch with an SMS chase, because that is what stalls",
    "Kickoff booking plus a week-one recap that starts the reporting habit",
  ],
  flow: makeFlow(
    [
      node("pr", "page-web", "Proposal", 40, 60, { props: { pageType: "sales", price: "$4,000/mo" } }),
      node("ik", "page-web", "Intake form", 40, 240, { props: { pageType: "opt-in", headline: "Access, brand, goals" } }),
      flow("f1", "Client Onboarding", 360, 40, 420, 1040),
      ...seq.nodes,
      node("bk", "page-booking", "Kickoff call", 880, 340, { props: { duration: "60 min" } }),
      node("out", "outcome-won", "Retainer live", 1200, 340, { props: { value: "$4,000/mo" } }),
      node("n1", "util-note", "Churn starts in week one", 40, 440, {
        notes:
          "Clients who don't complete intake in the first fortnight are the ones who churn in month three. Chase the form, not the feeling — it is the earliest measurable signal you get.",
      }),
    ],
    [
      edge("pr", "f1"),
      edge("ik", "f1"),
      ...seq.edges,
      edge("f1", "bk"),
      edge("bk", "out"),
    ]
  ),
};

export default def;
